import Vue from "vue";
import VesselActivityTable from "../components/tables/VesselActivityTable";

Vue.component('vessel-activities', {
  components: { VesselActivityTable },
  data() {
    return {
      selected: 'clicks'
    }
  },
  methods: {
    updateSelectedActivity(type) {
      this.selected = type;
    }
  }
});